import * as Yup from "yup"

const validationSchema = Yup.object().shape({
  message: Yup.string().trim().required('Votre message ne doit pas être vide')
})


export default validationSchema
